<template>
  <div>
    <div v-if="copyright" class="footer"
      :style="{color: setColors.footerText, backgroundColor: setColors.footerBg}">
      <div v-html="copyright"></div>
    </div>
    <div class="notranslate poweredBy">
      <a :target="poweredBy.name === 'iSTAY' ? '_blank' : '_self'"
        :href="poweredBy.name === 'iSTAY' ? 'http://istay.io/' : 'javascript:void(0);'">
        <span>powered by</span>
        <img :src="require(`@/assets/img/${poweredByLogo}.png`)" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: [
    'setting',
    'locale',
    'lang'
  ],
  computed: {
    setColors () {
      return {
        footerBg: this.setting.colors.footerBg ? this.setting.colors.footerBg : '#f9fafb',
        footerText: this.setting.colors.footerText ? this.setting.colors.footerText : '#676767'
      }
    },
    defaultCopyright () {
      return `© ${this.setting.title[this.lang]}.`
    },
    copyright () {
      const copy = this.setting.footer ? this.setting.footer.copyright[this.lang] : this.defaultCopyright
      return copy
    },
    poweredBy () {
      return this.$store.state.system.partner
    },
    poweredByUrl () {
      const partner = this.poweredBy.name
      const url = partner === 'iSTAY' ? 'http://istay.io/' : 'javascript:void(0);'
      return url
    },
    poweredByLogo () {
      const partner = this.poweredBy.name
      const img = partner === 'iSTAY' ? 'istay-orange' : 'CoreGuide'
      return img
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  font-size: 12px;
  line-height: 1.3;
}
.poweredBy {
  text-align: right;
  padding: 2px 15px;
  font-size: 10px;
  border-top: 1px solid $color-lgrey2;
  background-color: $bg-default;
  img {
    height: 10px;
    margin-left: 4px;
  }
}
</style>
